export class PersistService {
  static storage: Record<string, any> = {
    session: sessionStorage,
    local: localStorage,
  }

  static store(key: unknown, value: unknown, typeStorage = 'session'): void {
    this.storage[typeStorage].setItem(
      JSON.stringify(key),
      JSON.stringify(value)
    )
  }

  static fetch(key: unknown, typeStorage = 'session'): unknown {
    let data = this.storage[typeStorage].getItem(JSON.stringify(key))
    if (data !== null) {
      data = JSON.parse(data)
    }
    return data
  }

  static delete(key: unknown, typeStorage = 'session'): void {
    this.storage[typeStorage].removeItem(JSON.stringify(key))
  }

  static hasItem(key: string, typeStorage = 'session'): boolean {
    return !!this.fetch(key, typeStorage)
  }

  static clearAll(typeStorage = 'session'): void {
    this.storage[typeStorage].clear()
  }
}
